import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import PaginationComponent from "../Components/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import AdminActions from "../Redux/Actions/AdminActions";
import NoData from "../Components/NoData";
import { formatDateToDMY } from "../Utils/commonFiles";
import { Form } from "react-bootstrap";
import moment from "moment/moment";

export default function Transactions() {
  const transactionList = useSelector((e) => e.adminAuth.transactions);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const totalEntries = transactionList?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [currentPage, setCurrentPage] = useState(0);
  const [flag, setFlag] = useState(false);
  const [status, setStatus] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (location.pathname === "/transactions") {
      const params = new URLSearchParams(location.search);
      const page = parseInt(params.get("page") || "0", 10);
      const statusParam = params.get("status") || "";
      const searchParam = params.get("search") || "";

      setCurrentPage(page);
      setStatus(statusParam);
      setSearchQuery(searchParam);

      const queryParams = { page, limit: entriesPerPage };
      if (statusParam) queryParams.status = statusParam;
      if (searchParam) queryParams.search = searchParam;

      dispatch(startstopLoading(true));

      dispatch(AdminActions.getTransactions(queryParams))
        .then(() => dispatch(startstopLoading(false)))
        .catch((err) => {
          console.error("Error fetching transactions:", err);
          dispatch(startstopLoading(false));
        });
    }
  }, [location.search, dispatch, location.pathname, flag]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    updateUrlWithParams(page, status, searchQuery);
  };

  const handleChange = (id, val) => {
    dispatch(AdminActions.updateTransactionStatus({ id, status: val })).then(
      (res) => {
        setFlag(!flag);
      }
    );
  };

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatus(selectedStatus);
    updateUrlWithParams(0, selectedStatus, searchQuery);
  };

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearchQuery(searchValue);
    updateUrlWithParams(0, status, searchValue);
  };

  const updateUrlWithParams = (page, statusValue, searchValue) => {
    const params = new URLSearchParams();
    if (page && page !== 0) params.set("page", page);
    if (statusValue) params.set("status", statusValue);
    if (searchValue) params.set("search", searchValue);
    const qs = params.toString();
    navigate(qs ? `/transactions?${qs}` : `/transactions`);
  };

  const fetchTransactions = (page = 0, statusValue = "") => {
    // const queryParams = {
    //   page: page,
    //   limit: entriesPerPage,
    //   status: statusValue || "",
    // };
    const queryParams = { page, limit: entriesPerPage };
    if (statusValue) queryParams.status = statusValue;

    dispatch(startstopLoading(true));
    dispatch(AdminActions.getTransactions(queryParams))
      .then((res) => {
        dispatch(startstopLoading(false));
      })
      .catch((error) => {
        console.error("Error fetching transactions:", error);
        dispatch(startstopLoading(false));
      });
  };

  useEffect(() => {
    fetchTransactions(0, "");
  }, [dispatch]);

  // const getPendingStatusClass = (transaction) => {
  //   if (transaction.status === "ClientPaid") {
  //     return "status-payment-done";
  //   }

  //   if (transaction.status === "Pending" && transaction?.event?.eventDate) {
  //     const currentDate = moment().startOf("day");
  //     const eventDate = moment(transaction.event.eventDate).startOf("day");

  //     if (!eventDate.isValid()) {
  //       console.warn("Invalid eventDate:", transaction.event.eventDate);
  //       return "status-pending";
  //     }

  //     if (eventDate.isBefore(currentDate)) {
  //       return "status-pending-overdue";
  //     }
  //     return "status-pending";
  //   }
  //   return `status-${transaction.status.toLowerCase()}`;
  // };

  const getPendingStatusClass = (transaction = {}) => {
    const statusVal = (transaction.status || "").toString();

    if (statusVal === "ClientPaid") {
      return "status-payment-done";
    }

    if (statusVal === "Awaiting") {
      return "status-awaiting";
    }

    if (statusVal === "Pending" && transaction?.event?.eventDate) {
      const currentDate = moment().startOf("day");
      const eventDate = moment(transaction.event.eventDate).startOf("day");

      if (!eventDate.isValid()) {
        console.warn("Invalid eventDate:", transaction.event.eventDate);
        return "status-pending";
      }

      if (eventDate.isBefore(currentDate)) {
        return "status-pending-overdue";
      }
      return "status-pending";
    }

    // fallback: safe lowercasing
    return statusVal ? `status-${statusVal.toLowerCase()}` : "status-unknown";
  };

  return (
    <Layout>
      <Container fluid>
        <div className="comn-table-title">
          <h3>
            Transactions <span></span>
          </h3>

          <Form.Group className="mb-3" controlId="musician">
            {/* <Form.Label>Status</Form.Label> */}
            <Form.Select
              id="category"
              name="musician"
              value={status}
              onChange={handleStatusChange}
              className={`custom-select ${status ? `status-${status.toLowerCase()}` : ""
                }`}
              aria-label="Filter transactions by status"
            >
              <option value="" className="option-pending">
                All
              </option>
              <option value="" className="">
                All
              </option>
              <option value="ClientPaid" className="option-awaiting">
                Awaiting Confirmation
              </option>
              <option value="Pending" className="option-pending">
                Pending
              </option>
              <option value="Complete" className="option-complete">
                Complete
              </option>
              <option value="Overdue" className="option-overdue">
                Overdue
              </option>
            </Form.Select>
          </Form.Group>
        </div>

        <div className="filters">
          <div className="inner-filter-field">
            <div class="table-responsive">
              {transactionList?.transaction?.length ? (
                <Table size="sm" className="table-cmn">
                  <thead>
                    <tr>
                      <th>
                        <div className="user-checkbox">
                          {/* <div className="remember-check">
                            <input
                              type="checkbox"
                              class="red"
                              id="filled-in-box"
                            />
                          </div> */}
                          Date
                        </div>
                      </th>
                      <th>Package</th>
                      <th>Client Name</th>
                      <th>Reference No.</th>
                      <th>Amount </th>
                      <th>Notes/Details</th>
                      <th>Status </th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionList?.transaction?.map((res) => {
                      let val = getPendingStatusClass(res);
                      return (
                        <tr key={res._id}>
                          <td>
                            <div className="first-user">
                              {/* <div className="remember-check">
                                <input
                                  type="checkbox"
                                  class="red"
                                  id="filled-in-box"
                                />
                              </div> */}
                              <div className="user-profile">
                                {formatDateToDMY(res.createdAt)}
                              </div>
                            </div>
                          </td>
                          <td>{res.event.eventName}</td>
                          <td>{res.client.fullName}</td>
                          <td>{res?.event?.reference || "N/A"}</td>
                          <td>£{res.amount}</td>
                          <td>
                            {res.amount === 100
                              ? "Deposit"
                              // :
                              // res.status === "Overdue" ||
                              //   res.status === "Pending"
                              //   ? "Final Balance"
                              : "Final Balance"}
                            {/* : "Deposit"} */}
                          </td>
                          <td>
                            <div className="mb-3 comp-pending-drop">
                              <select
                                id="category"
                                value={res.status}
                                onChange={(e) =>
                                  handleChange(res._id, e.target.value)
                                }
                                className={`form-control custom-select ${getPendingStatusClass(
                                  res
                                )}`}
                              >
                                <option disabled>Select</option>
                                <option value="Pending" className="">
                                  Pending
                                </option>
                                <option
                                  value="Complete"
                                  className="option-complete"
                                >
                                  Complete
                                </option>
                                <option
                                  value="Overdue"
                                  className="option-overdue"
                                >
                                  Overdue
                                </option>
                                <option
                                  value="ClientPaid"
                                  className="option-payment-done"
                                >
                                  Awaiting Confirmation
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <NoData />
              )}
              {transactionList?.total > 10 && (
                <PaginationComponent
                  currentPage={parseInt(
                    new URLSearchParams(location.search).get("page") || "0"
                  )}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={totalEntries}
                  entriesPerPage={entriesPerPage}
                />
              )}
            </div>
          </div>
        </div>
        <div className="mb-0">
          <p className="pb-4"></p>
        </div>
      </Container>

      <style jsx>{`
        /* Status styles for the select dropdown button */

        .form-control.custom-select.status-payment-done {
          background-color: #61a3daff; /* Green background for Payment done */
          color: #ffffff; /* White text for contrast */
          border-color: #61a3daff;
        }

        .form-control.custom-select.status-pending {
          background-color: #000000; /* Black background for Pending */
          color: #ffffff; /* White text for contrast */
        }
        .form-control.custom-select.status-pending-overdue {
          background-color: #fd7e14 !important; /* Orange background for Pending Overdue */
          color: #ffffff !important; /* White text for contrast */
          border-color: #fd7e14 !important; /* Orange border to match */
        }
        .form-control.custom-select.status-complete {
          background-color: #28a745; /* Green background for Complete */
          color: #ffffff; /* White text for contrast */
        }
        .form-control.custom-select.status-overdue {
          background-color: #dc3545; /* Red background for Overdue */
          color: #ffffff; /* White text for contrast */
        }

        /* Ensure the select button appearance is consistent */
        .form-control.custom-select {
          border: 1px solid #ced4da; /* Bootstrap default border */
          padding: 0.375rem 0.75rem; /* Bootstrap default padding */
          border-radius: 0.25rem; /* Bootstrap default border-radius */
          appearance: none; /* Remove default browser styling */
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"); /* Custom dropdown arrow */
          background-repeat: no-repeat;
          background-position: right 0.75rem center;
          background-size: 1rem;
          transition: background-color 0.2s ease, color 0.2s ease,
            border-color 0.2s ease;
        }

        /* Style the options in the dropdown */
        .option-pending {
          background-color: #000000; /* Black background for Pending */
          color: #ffffff; /* White text for contrast */
        }
        .option-awaiting {
          background-color: #61a3daff; /* Black background for Pending */
          color: #ffffff; /* White text for contrast */
        }
        .option-complete {
          background-color: #28a745; /* Green background for Complete */
          color: #ffffff; /* White text for contrast */
        }
        .option-overdue {
          background-color: #dc3545; /* Red background for Overdue */
          color: #ffffff; /* White text for contrast */
        }

        /* Ensure options are styled when dropdown is open */
        .form-control.custom-select option {
          background-color: #ffffff; /* Default white background for unselected options */
          color: #000000; /* Default black text for unselected options */
        }

        /* Override any Bootstrap or browser defaults for pending-overdue */
        .form-control.custom-select.status-pending-overdue,
        .form-control.custom-select.status-pending-overdue:focus,
        .form-control.custom-select.status-pending-overdue:hover {
          background-color: #fd7e14 !important; /* Ensure orange persists */
          color: #ffffff !important;
          border-color: #fd7e14 !important;
        }
      `}</style>
    </Layout>
  );
}
